module.exports = __webpack_public_path__ + "img/step6-09.2903b921.jpg";